import { Fragment, MarkType, Node, ProseMirrorNode, Schema } from 'prosemirror-model';

/*
 * The base class for schemas to be used with the collab server.
 */
export abstract class CollabSchema<Nodes extends string = any, Marks extends string = any> extends Schema<Nodes, Marks> {
  get name(): string { return 'collab-schema'; }
  get version(): string { return '0.0.0'; }
  get changeMark(): MarkType { return this.marks[this.madcapChangeMarkName]; }
  /** Indicates whether the document code can be empty. */
  get codeCanBeEmpty(): boolean { return false; }

  // The madcap change mark name (defined by the schema modules)
  madcapChangeMarkName: string;

  abstract codeToDoc(code: string): ProseMirrorNode;
  abstract nodeToCode(node: Node): string;
  abstract fragmentToCode(fragment: Fragment): string;
  abstract validate(code: string, options?: any): Error;

  // NOTE: this should do a semver comparison but the semver library isn't available on the client so just return true here for now
  // This function can be overridden elsewhere to actually compare the versions
  compatible(version: string): boolean {
    return true;
  }

  /**
   * Determines whether to skip exporting the given attribute to the editor DOM.
   * Defaults to not skipping any attributes.
   * @param attrName The name of the attribute.
   * @param attrValue The value of the attribute.
   * @returns true to skip exporting, false to include it.
   */
  skipAttrEditorExport(attrName: string, attrValue: string): boolean {
    return false;
  }
}
